<div class="flex" style="margin-top: 15px;" *ngIf="triggerRules && triggerRules.length > 0">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-striped p-datatable-hoverable-rows">
      <p-table
        [(first)]="first"
        [(rows)]="rows"
        [value]="triggerRules"
        [totalRecords]="totalTriggerRules"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        [rowsPerPageOptions]="[10,25,50]"
        (onPage)="onPageChange($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 18rem" pSortableColumn="name">
              {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="expression">
              {{'attribute.expression' | transloco}}<p-sortIcon field="expression"></p-sortIcon></th>
            <th pSortableColumn="trigger">
              {{'attribute.trigger' | transloco}}<p-sortIcon field="trigger"></p-sortIcon></th>
            <th pSortableColumn="organization.name">
              {{'model.organization' | transloco}}<p-sortIcon field="organization.name"></p-sortIcon></th>
            <th pSortableColumn="active">
              {{'attribute.active' | transloco}}<p-sortIcon field="active"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rule>
          <tr *ngIf="!loadingTriggerRules">
            <td>
              <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
              {{rule.name}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.expression' | transloco}}</span>
              {{rule.expression}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.trigger' | transloco}}</span>
              {{rule.trigger}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.organization' | transloco}}</span>
              {{rule.organization ? rule.organization.name : ''}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.active' | transloco}}</span>
              {{rule.active}}
            </td>
          </tr>
          <tr *ngIf="loadingTriggerRules">
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalTriggerRules == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalTriggerRules > 0">
            Showing {{first+1}}
            to {{(first+rows) >= totalTriggerRules ? totalTriggerRules : (first+rows)}}
            of {{totalTriggerRules}} {{totalTriggerRules > 1 ? 'entries':'entry'}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="triggerRules && triggerRules.length == 0">
  <div class="card w-full">
    <p class="text-xl text-center p-6 font-italic">{{'empty.triggerRules' | transloco}}</p>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!triggerRules">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
